import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// import LanguageDetector from 'i18next-browser-languagedetector'
import en_translation from './locales/en/translation.json'
// import fr_translation from './locales/fr/translation.json'
import { DEFAULT_LANGUAGE, IS_DEV } from '../constants'

// Only the default language ships in the main bundle. `uk` (62KB of JSON) is only ever
// switched to from the staff-only language toggle in the footer, so it's fetched on demand
// via loadLanguageResource instead of costing every visitor a bigger initial parse/eval.
export const SUPPORTED_LANGUAGES = ['en', 'uk']

const localeLoaders: Record<string, () => Promise<{ default: object }>> = {
  uk: () => import('./locales/uk/translation.json'),
  // fr: () => import('./locales/fr/translation.json'),
}

export async function loadLanguageResource(lng: string) {
  if (i18n.hasResourceBundle(lng, 'translation') || !localeLoaders[lng]) {
    return
  }
  const { default: translation } = await localeLoaders[lng]()
  i18n.addResourceBundle(lng, 'translation', translation)
}

// translation catalog
const resources = {
  en: {
    translation: en_translation,
  },
}

i18n
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    debug: IS_DEV,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources,
    compatibilityJSON: 'v4',
  })

export default i18n
